export default {
  title: "Prestataires",
  description: "Gérez vos prestataires de mariage",
  subtitle: "Ajoutez et gérez vos prestataires de mariage",
  addVendor: "Ajouter un prestataire",
  editVendor: "Modifier le prestataire",
  deleteVendor: "Supprimer le prestataire",
  noVendors: "Aucun prestataire trouvé",
  addFirstVendor: "Ajoutez votre premier prestataire",
  hired: "Engagé",
  engagedVendors: "Prestataires engagés",
  noEngagedVendors: "Aucun prestataire engagé pour le moment",
  allVendors: "Tous les prestataires",
  more: "autre(s)",
  vendorDeleted: "Prestataire supprimé avec succès",
  vendorCreated: "Prestataire créé avec succès",
  vendorUpdated: "Prestataire mis à jour avec succès",
  totalVendors: "{{count}} prestataires",
  
  categories: {
    venue: "Lieu",
    religious_venue: "Lieu de culte",
    city_hall: "Mairie",
    catering: "Traiteur",
    photography: "Photographie",
    videography: "Vidéographie",
    music: "Musique",
    florist: "Fleuriste",
    cake: "Gâteau",
    dress: "Robe",
    suit: "Costume",
    hair_makeup: "Coiffure & Maquillage",
    decoration: "Décoration",
    transportation: "Transport",
    flowers: "Fleurs",
    transport: "Transport",
    beauty: "Beauté",
    other: "Autre",
    select: "Sélectionner une catégorie",
    none: "Aucun",
    photos: "Photos",
    preparation: "Préparation",
    reminder: "Rappel",
    task: "Tâche",
    vendor: "Prestataire",
    vendors: "Prestataires",
    custom: "Personnalisé"
  },

  form: {
    name: "Nom",
    category: "Catégorie",
    contact: "Contact",
    email: "Email",
    phone: "Téléphone",
    address: "Adresse",
    website: "Site web",
    price: "Prix",
    notes: "Notes",
    rating: "Note",
    status: "Statut",
    statusHelper: "L'état d'avancement détermine la gestion du budget et des tâches.",
    contactName: "Nom du contact",
    deposit: "Acompte",
    depositPaid: "Acompte payé",
    contractSigned: "Contrat signé",
    country: "Pays",
    errors: {
      nameRequired: "Le nom est requis",
      categoryRequired: "La catégorie est requise",
      statusRequired: "Le statut est requis",
      pricePositive: "Le prix doit être positif",
      depositPositive: "L'acompte doit être positif",
      capacityPositive: "La capacité doit être un nombre positif"
    },
    new: "Nouveau prestataire",
    edit: "Modifier le prestataire",
    title: "Détails du prestataire",
    namePlaceholder: "Nom du prestataire",
    company: "Entreprise",
    categoryPlaceholder: "Sélectionnez une catégorie",
    emailPlaceholder: "Adresse email",
    phonePlaceholder: "Numéro de téléphone",
    websitePlaceholder: "URL du site web",
    addressPlaceholder: "Adresse du prestataire",
    notesPlaceholder: "Notes complémentaires",
    submit: "Enregistrer",
    cancel: "Annuler",
    confirmCancel: "Annuler",
    contactInfo: "Informations de contact",
    capacity: "Capacité maximale",
    capacityPlaceholder: "Nombre maximum de personnes",
    contactNamePlaceholder: "Nom du contact",
    description: "Description",
    dueDate: "Date d'échéance",
    priority: "Priorité"
  },

  status: {
    contacted: "Contacté",
    quote: "Devis reçu",
    booked: "Réservé",
    hired: "Engagé",
    deposit_paid: "Acompte payé",
    paid: "Payé",
    cancelled: "Annulé",
    to_contact: "À contacter",
    meeting_scheduled: "Rendez-vous prévu",
    meetingScheduled: "Rendez-vous prévu",
    quote_received: "Devis reçu",
    quoteReceived: "Devis reçu",
    depositPaid: "Acompte payé",
    completed: "Terminé",
    researching: "Recherche",
    confirmed: "Confirmé",
    pending: "En attente",
    declined: "Refusé"
  },

  actions: {
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    contact: "Contacter",
    book: "Réserver",
    add: "Ajouter",
    addLong: "Ajouter un nouveau prestataire",
    importGuests: "Importer des invités"
  },

  messages: {
    vendorAdded: "Prestataire ajouté avec succès",
    vendorUpdated: "Prestataire mis à jour avec succès",
    vendorDeleted: "Prestataire supprimé avec succès",
    error: "Une erreur est survenue",
    createSuccess: "Prestataire ajouté avec succès",
    updateSuccess: "Prestataire mis à jour avec succès",
    deleteSuccess: "Prestataire supprimé avec succès",
    deleteConfirm: "Êtes-vous sûr de vouloir supprimer ce prestataire ?"
  },

  confirm: {
    delete: "Êtes-vous sûr de vouloir supprimer ce prestataire ?",
    budgetRemoval: {
      title: "Suppression du budget",
      message: "Êtes-vous sûr de vouloir supprimer le budget associé à ce prestataire ?",
      confirm: "Oui, supprimer",
      cancel: "Annuler"
    }
  },

  confirmations: {
    delete: "Êtes-vous sûr de vouloir supprimer ce prestataire ?"
  },

  logs: {
    addingVendor: "Ajout d'un prestataire...",
    updatingVendor: "Mise à jour du prestataire..."
  },

  errors: {
    submit: "Erreur lors de l'enregistrement du prestataire",
    addVendor: "Erreur lors de l'ajout du prestataire",
    updateVendor: "Erreur lors de la mise à jour du prestataire",
    deleteVendor: "Erreur lors de la suppression du prestataire",
    loadVendors: "Erreur lors du chargement des prestataires",
    userOrWeddingNotFound: "Utilisateur ou événement non trouvé"
  },

  search: {
    title: "Trouver des prestataires",
    searchPlaceholder: "Rechercher des prestataires",
    locationPlaceholder: "Ville ou code postal",
    categoryPlaceholder: "Sélectionner une catégorie",
    sort: "Trier par",
    sortOptions: {
      relevance: "Pertinence",
      rating: "Note",
      reviews: "Avis",
      distance: "Distance",
      name: "Nom"
    },
    findVendors: "Trouver des prestataires",
    googleShort: "Rechercher",
    googlePlaceholder: "Rechercher un prestataire",
    googleResults: "Résultats de recherche",
    googleNoResults: "Aucun résultat trouvé",
    googleError: "Une erreur est survenue lors de la recherche",
    googleErrorShort: "Erreur de recherche",
    locationRequired: "Veuillez entrer une localisation pour la recherche",
    countries: {
      FR: "🇫🇷 France",
      BE: "🇧🇪 Belgique",
      CH: "🇨🇭 Suisse",
      ES: "🇪🇸 Espagne",
      IT: "🇮🇹 Italie",
      DE: "🇩🇪 Allemagne",
      GB: "🇬🇧 Royaume-Uni",
      IE: "🇮🇪 Irlande",
      CA: "🇨🇦 Canada",
      US: "🇺🇸 États-Unis",
      AU: "🇦🇺 Australie",
      OTHER: "🌍 Autre"
    },
    filters: {
      title: "Filtres",
      category: "Catégorie",
      status: "Statut",
      search: "Rechercher",
      country: "Pays",
      location: "Où ?",
      radius: "Rayon"
    },
    google: "Recherche Google",
    googleLong: "Rechercher sur Google (lieux, entreprises, etc.)",
    placeholder: "Ville ou code postal...",
    noResults: "Aucun résultat trouvé",
    noResultsDescription: "Essayez de modifier vos critères de recherche ou d'élargir votre zone géographique.",
    reset: "Réinitialiser la recherche",
    searching: "Recherche en cours",
    searchingDescription: "Nous recherchons les meilleurs prestataires...",
    addVendor: "Ajouter ce prestataire",
    add: "Ajouter",
    site: "Site web",
    phone: "Téléphone",
    resultsCountSingular: "prestataire trouvé",
    resultsCountPlural: "prestataires trouvés",
    reviews: "avis",
    recommended: "Recommandé",
    new: "Nouveau"
  },
  
  empty: {
    title: "Aucun prestataire",
    description: "Commencez par ajouter vos prestataires de mariage"
  },

  filters: {
    title: "Filtres",
    category: "Catégorie",
    status: "Statut",
    all: "Tous",
    group: "Groupe",
    search: "Rechercher un prestataire",
    events: "Événements",
    clear: "Effacer les filtres",
    apply: "Appliquer",
    previous: "Précédent",
    next: "Suivant",
    reset: "Réinitialiser",
    allCategories: "Toutes les catégories"
  },

  groups: {
    family: "Famille",
    friends: "Amis",
    colleagues: "Collègues",
    other: "Autre"
  },

  events: {
    ceremony: "Cérémonie",
    reception: "Réception",
    both: "Les deux"
  },

  sort: {
    title: "Trier par",
    options: {
      name: "Nom",
      category: "Catégorie",
      status: "Statut",
      price: "Prix",
      notes: "Notes"
    }
  },

  modal: {
    title: "Détails du prestataire",
    readOnly: "Lecture seule",
    edit: "Modifier",
    share: "Partager",
    personalInfo: "Informations personnelles",
    companyInfo: "Informations de l'entreprise",
    contactInfo: "Informations de contact",
    notes: "Notes",
    budget: "Budget",
    documents: "Documents",
    timeline: "Timeline",
    tasks: "Tâches",
    reviews: "Avis",
    messages: "Messages",
    payments: "Paiements",
    contracts: "Contrats"
  },

  details: {
    contact: "Contact",
    pricing: "Tarifs",
    documents: "Documents",
    appointments: "Rendez-vous",
    payments: "Paiements"
  },

  vendors: {
    filters: {
      status: "Statut",
      all: "Tous",
      group: "Groupe",
      events: "Événements"
    },
    status: {
      confirmed: "Confirmé",
      pending: "En attente",
      declined: "Refusé"
    },
    groups: {
      family: "Famille",
      friends: "Amis",
      colleagues: "Collègues",
      other: "Autre"
    },
    events: {
      ceremony: "Cérémonie",
      reception: "Réception",
      both: "Les deux"
    },
    sort: {
      options: {
        name: "Nom",
        category: "Catégorie",
        status: "Statut",
        price: "Prix",
        notes: "Notes"
      }
    }
  },

  success: {
    budgetUpdated: "Budget mis à jour avec succès",
    vendorAdded: "Prestataire ajouté avec succès",
    vendorAndBudgetUpdated: "Prestataire et budget mis à jour avec succès",
    vendorUpdated: "Prestataire mis à jour avec succès"
  }
};
